import { useCallback, useState } from 'react';

/**
 * Custom hook to provide a resettable key for remounting components.
 * @returns [key, resetKey] - key for the component, resetKey function to update it.
 */
export const useResetKey = (keyPrefix: string): [string, () => void] => {
  const [key, setKey] = useState(0);

  const resetKey = useCallback(() => {
    setKey((prev) => prev + 1); // Increment key to force re-render
  }, []);

  const keyName = `${keyPrefix}${key}`;

  return [keyName, resetKey];
};
